const invoicePaymentTermsApi = {
  valid(value: unknown): boolean {
    return value !== '' && value !== null && value !== undefined && Number.isInteger(Number(value)) && Number(value) >= 0 && Number(value) <= 365
  },
  days(settings: Record<string, any> = {}): number {
    const value = settings.paymentDays ?? settings.defaultPaymentDays ?? 14
    return invoicePaymentTermsApi.valid(value) ? Number(value) : 14
  },
  dueDate(date: string, settings: Record<string, any> = {}): string {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return ''
    const parsed = new Date(`${date}T00:00:00Z`)
    if (!Number.isFinite(parsed.getTime()) || parsed.toISOString().slice(0, 10) !== date) return ''
    parsed.setUTCDate(parsed.getUTCDate() + invoicePaymentTermsApi.days(settings))
    return parsed.toISOString().slice(0, 10)
  },
}
window.PlummeInvoicePaymentTerms = invoicePaymentTermsApi
